import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./CancelScreen.module.css";

const CancelScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation("translation");

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const originUrl = searchParams.get("origin_url") || "/";

    const timer = setTimeout(() => {
      navigate(originUrl);
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate, location]);

  return (
    <div className={styles.cancelScreen}>
      <h1>{t("payment.cancel.title")}</h1>
      <p>{t("payment.cancel.message")}</p>
      <p>
        {t("payment.cancel.manualRedirectPrefix")}
        <a href="/">{t("payment.cancel.manualRedirectLink")}</a>
        {t("payment.cancel.manualRedirectSuffix")}
      </p>
    </div>
  );
};

export default CancelScreen;
